module.exports = __webpack_public_path__ + "static/media/24_hours.6c1fc078.svg";